// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2c937396432d97e63bb3","655":"d030591017fe4687c040"}[chunkId] + ".js";
};